module.exports = __webpack_public_path__ + "img/clamp_M.440427f2.png";